import { Paper, Stack } from '@mantine/core';
import { Dispatch, FC, SetStateAction } from 'react';

import { FieldAnswer } from '../../../lib/types/validation';

import {
  UseValidationFormReturn,
  ValidationFormProvider,
} from '../utils/validation-form';
import { FieldMap } from './field-map';
import { FieldsNavbar } from './fields-navbar';
import { ValidationForm } from './validation-form';

interface PerFieldStepProps {
  currentField?: FieldAnswer;
  currentFieldIndex: number;
  fieldsCount: number;
  form: UseValidationFormReturn;
  hasMultipleFields: boolean;
  isCurrentFieldComplete: boolean;
  isFormComplete: boolean;
  isPending: boolean;
  onBackToChoice: () => void;
  onConfirm: () => void;
  progressValue: number;
  setCurrentFieldIndex: Dispatch<SetStateAction<number>>;
  setProgressValue: Dispatch<SetStateAction<number>>;
}

export const PerFieldStep: FC<PerFieldStepProps> = ({
  currentField,
  currentFieldIndex,
  fieldsCount,
  form,
  hasMultipleFields,
  isCurrentFieldComplete,
  isFormComplete,
  isPending,
  onBackToChoice,
  onConfirm,
  progressValue,
  setCurrentFieldIndex,
  setProgressValue,
}) => {
  if (fieldsCount === 0) {
    return null;
  }

  return (
    <Stack>
      <FieldsNavbar
        currentFieldIndex={currentFieldIndex}
        fieldsLength={fieldsCount}
        handleConfirm={onConfirm}
        hasMultipleFields={hasMultipleFields}
        isCurrentFieldComplete={isCurrentFieldComplete}
        isFormComplete={isFormComplete}
        isPending={isPending}
        onBackToChoice={onBackToChoice}
        progressValue={progressValue}
        setCurrentFieldIndex={setCurrentFieldIndex}
        setProgressValue={setProgressValue}
      />
      <Paper p="md">
        <FieldMap currentField={currentField} />
        <ValidationFormProvider form={form}>
          <ValidationForm currentFieldIndex={currentFieldIndex} />
        </ValidationFormProvider>
      </Paper>
    </Stack>
  );
};
